import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination, XTableHOC } from '@/components/xqxc_ui';
import { Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { regFenToYuan } from '@/util/money';
import { tooltipStyle, tooltip, tooltipClick } from '@/components/TableCell';

class OrderTable extends React.Component {
    _takeColumns = () => ([
        {
            title: '配送单号',
            dataIndex: 'deliveryId',
            key: 'deliveryId',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => tooltipClick(`${item.type || ''}${text}`, () => {
                this.props.tableAction(item.id, 'info', item);
            })
        },
        {
            title: '投诉人账号',
            dataIndex: 'sourceTel',
            key: 'sourceTel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '投诉人',
            dataIndex: 'sourceName',
            key: 'sourceName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        }, 
        // {
        //     title: '被投诉人类型',
        //     dataIndex: 'targetType',
        //     key: 'targetType',
        //     width: '8%',
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        {
            title: '被投诉人账号',
            dataIndex: 'riderTel',
            key: 'riderTel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '被投诉人',
            dataIndex: 'riderName',
            key: 'riderName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },        
        {
            title: '投诉原因',
            dataIndex: 'reasons',
            key: 'reasons',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '投诉状态',
            dataIndex: 'processStateName',
            key: 'processStateName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '投诉时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: text => text ? tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss')) : ''
        },
        {
            title: '操作',
            dataIndex: 'key',
            key: 'key',
            align: 'center',
            width: '10%',
            render: (text, record) => this._renderActionCell(record.id, record)
        }
    ]);

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }
    _renderTextMoneyCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {regFenToYuan(text)}
            </div>
        );
    }
    _renderTextCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {text}
            </div>
        );
    };

    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                { record.processState == 'TODO' && <div className={styles.item} onClick={() => tableAction(key, 'handle', record)}>处理</div>}
                { record.processState == 'TODO' && <div className={styles.item} onClick={() => tableAction(key, 'create', record)}>新建罚单</div> }
            </div>
        );
    }

    // 表格复选输入
    _rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(selectedRows);
        }
    };

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    // rowSelection={this._rowSelection}
                    rowKey={record => record.id}
                    columns={this._takeColumns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

OrderTable.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default OrderTable;
// export default XTableHOC(OrderTable);